module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.item) ? _c('div', {
    staticClass: "component-backoffice-transactions"
  }, [(_vm.$is('listing')) ? _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "inner-content"
  }, [_c('cardN', {
    attrs: {
      "showBullets": true,
      "showAction": true,
      "columns": 6
    }
  }, [_c('div', {
    attrs: {
      "slot": "actionBullets"
    },
    slot: "actionBullets"
  }), _c('transaction-fields', {
    attrs: {
      "slot": "n1",
      "item": _vm.item,
      "fieldName": 'transaction-id'
    },
    slot: "n1"
  }), _c('transaction-fields', {
    attrs: {
      "slot": "n1",
      "item": _vm.item,
      "fieldName": 'transaction-date'
    },
    slot: "n1"
  }), _c('transaction-fields', {
    attrs: {
      "slot": "n2",
      "item": _vm.item,
      "fieldName": 'transaction-client'
    },
    slot: "n2"
  }), _c('transaction-fields', {
    attrs: {
      "slot": "n3",
      "item": _vm.item,
      "fieldName": 'transaction-payment-method'
    },
    slot: "n3"
  }), _c('transaction-fields', {
    attrs: {
      "slot": "n4",
      "item": _vm.item,
      "fieldName": 'invoice-link'
    },
    slot: "n4"
  }), _c('transaction-fields', {
    attrs: {
      "slot": "n5",
      "item": _vm.item,
      "fieldName": 'transaction-amount'
    },
    slot: "n5"
  }), _c('transaction-fields', {
    attrs: {
      "slot": "n6",
      "item": _vm.item,
      "fieldName": 'transaction-status'
    },
    slot: "n6"
  }), _c('transaction-fields', {
    attrs: {
      "slot": "n7",
      "item": _vm.item,
      "fieldName": 'transaction-date'
    },
    slot: "n7"
  }), _c('div', {
    attrs: {
      "slot": "actionPage"
    },
    slot: "actionPage"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'transaction',
        params: {
          id: _vm.item.id
        }
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-right fa-3x action"
  })])], 1)], 1)], 1)]) : _vm._e(), (_vm.$is('oneLook')) ? _c('div', {
    staticClass: "one-look"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'transaction',
        params: {
          id: _vm.item.id
        }
      }
    }
  }, [_vm._v("TR" + _vm._s(_vm.item.id))])], 1) : _vm._e(), (_vm.$is('client-list')) ? _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "inner-content"
  }, [_c('cardN', {
    attrs: {
      "showBullets": true,
      "showAction": true,
      "columns": 5
    }
  }, [_c('transaction-fields', {
    attrs: {
      "slot": "n1",
      "item": _vm.item,
      "fieldName": 'transaction-id'
    },
    slot: "n1"
  }), _c('transaction-fields', {
    attrs: {
      "slot": "n1",
      "item": _vm.item,
      "fieldName": 'transaction-date'
    },
    slot: "n1"
  }), _c('transaction-fields', {
    attrs: {
      "slot": "n2",
      "item": _vm.item,
      "fieldName": 'transaction-payment-method'
    },
    slot: "n2"
  }), _c('transaction-fields', {
    attrs: {
      "slot": "n3",
      "item": _vm.item,
      "fieldName": 'invoice-link'
    },
    slot: "n3"
  }), _c('transaction-fields', {
    attrs: {
      "slot": "n4",
      "item": _vm.item,
      "fieldName": 'transaction-amount'
    },
    slot: "n4"
  }), _c('transaction-fields', {
    attrs: {
      "slot": "n5",
      "item": _vm.item,
      "fieldName": 'transaction-status'
    },
    slot: "n5"
  }), _c('div', {
    attrs: {
      "slot": "actionPage"
    },
    slot: "actionPage"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'transaction',
        params: {
          id: _vm.item.id
        }
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-right fa-3x action"
  })])], 1)], 1)], 1)]) : _vm._e(), (_vm.$is('detail')) ? _c('div', {
    staticClass: "detail"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "column card mr-4 p-2"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('h2', [_vm._v("Transaction")]), _c('div', [_vm._v("TR" + _vm._s(_vm.item.id) + "  "), _c('strong', [_vm._v(_vm._s(_vm.item.status))]), _c('br'), _c('small', [_vm._v(_vm._s(_vm.item.response.message))])]), _c('div', [_vm._v("Gateway id  "), _c('a', {
    on: {
      "click": _vm.viewOnGateway
    }
  }, [_vm._v(_vm._s(_vm.item.transaction_uid))])]), _c('div', {
    staticClass: "field",
    style: (_vm.item.amount < 0 ? 'color:#cc4b37' : '')
  }, [_vm._v(_vm._s(_vm.$priceWithcurrency(_vm.item.amount.toFixed(2))))])]), _c('div', {
    staticClass: "column"
  }, [_c('h2', [_vm._v("Client")]), _c('router-link', {
    attrs: {
      "to": {
        name: 'client',
        params: {
          id: _vm.item.client_id
        }
      }
    }
  }, [(_vm.item.client_organization_name) ? _c('span', [_vm._v(_vm._s(_vm.item.client_organization_name))]) : _c('span', [_vm._v(_vm._s(_vm.item.name) + " " + _vm._s(_vm.item.surname))])])], 1)])]), _c('div', {
    staticClass: "column card mr-4 p-2"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('h2', [_vm._v("Invoice")]), (_vm.item.invoice.id) ? _c('router-link', {
    attrs: {
      "to": {
        name: 'invoice',
        params: {
          id: _vm.item.invoice.id
        }
      }
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.item.invoice.type) + _vm._s(_vm.item.invoice_internal_id) + " (" + _vm._s(_vm.item.invoice_id) + ")")])]) : _vm._e()], 1), _c('div', {
    staticClass: "column"
  }, [_c('h2', [_vm._v("Payment Method")]), _c('span', [_vm._v("PM" + _vm._s(_vm.item.payment_method_id) + " " + _vm._s(_vm.item.payment_name))]), _c('div', [_vm._v(_vm._s(_vm.item.payment_method_provider))])])])])]), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "columns card mr-4 p-2"
  }, [_c('div', {
    staticClass: "inner-content"
  }, [_c('h2', [_vm._v("Raw response")]), _vm._l((_vm.getResponse), function(value, key) {
    return _c('pre', [_vm._v(_vm._s(key) + " : " + _vm._s(value))])
  })], 2)])])]) : _vm._e()]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-1bff82b7!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/backoffice/Transaction.vue
// module id = 2308
// module chunks = 1